import { Search } from "@mui/icons-material"
import { Grid, Typography, Divider } from "@mui/material"
import { useSearchConfig } from "../../context/SearchConfigProvider/useSearchConfig"
import WorkSpaceItemListFileComponentImage from "../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import { useNavigate, useParams } from "react-router-dom";

export const AllResults = () => {

    const { workspaces, searchTerm } = useSearchConfig();
    const navigate = useNavigate();
    const { nameOrg } = useParams();

    return (
        <Grid
            container 
            spacing={2}
            paddingRight="30px"
            paddingLeft="30px"
        >
            <Grid
                item
                display="flex"
                alignItems="center"
                gap={1}
                xs={12}
                marginBottom="11px"
            >
                <Search 
                    sx={{
                        color: "#22638D"
                    }}
                />
                <Typography
                    fontSize="27px"
                    fontWeight={600}
                >
                    Resultados de busca
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                marginBottom="20px"
            >
                <Typography
                    sx={{
                        opacity: .3
                    }}
                    component="span"
                >
                    Resultado encontrado para
                    <Typography
                        fontWeight="600"
                        component="span"
                        marginLeft={1}
                    >
                        {searchTerm}
                    </Typography>
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
            >
                <Divider 
                    sx={{
                        width: "100%"
                    }}
                />
            </Grid>
            <Grid
                item
                xs={12}
                marginBottom="12px"
                marginTop="12px"
            >
                <Grid container>
                    <Grid
                        item
                        xs={6}
                    >
                        <Typography
                            sx={{
                                opacity: .3
                            }}
                        >
                            Nome
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                    >
                        <Typography
                            sx={{
                                opacity: .3
                            }}
                        >
                            Local
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            { workspaces?.map(x => (
                <Grid
                    item
                    xs={12}
                    sx={{
                       border: "1px solid #0000001A",
                       borderRadius: "4px",
                       marginBottom: 1,
                       cursor: "pointer",
                       transition: "ease .3",
                       ':hover': {
                            opacity: .3
                       }
                    }}
                    padding="15px"
                    onClick={() => {
                        navigate(`/${nameOrg}/${x.accessSlug}`)
                    }}
                >
                    <Grid
                        container
                    >
                        <Grid 
                            item
                            xs={6}
                            display="flex"
                            alignItems="center"
                            gap={0.5}                        >
                            <WorkSpaceItemListFileComponentImage 
                                boxLayout={false}
                                extension={x.extension!}
                                widthIcon="20px"
                                isFolder={false}
                            />
                            <Typography
                                marginLeft={2}
                                maxWidth="150px"
                                textOverflow="ellipsis"
                                overflow="hidden"
                                whiteSpace="nowrap"
                                textAlign="center"
                            >
                                { x.name! }
                            </Typography>
                        </Grid>
                        <Grid 
                            item
                            xs={6}
                            sx={{
                                opacity: .3
                            }}
                        >
                            { x.presentationSlug }
                        </Grid>
                    </Grid>
                </Grid>
            )) }
        </Grid>
    )
}